import React from 'react'
import { Grid, Button, Typography, Card, Box, Stack, Chip, Alert } from '@mui/material';
import Config from '../config/config';
import "./CardProducts.css";
import RowSimple from './RowSimple';
const numeral = require('numeral');

const CardProduct = ({ product, addToCart, verProdutoProps }) => {
    const SEM_IMAGEM = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg';
    const FOTO_TRATAMENTO = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/foto_tratamento.jpg';

    const imgStyle = { width: '100%', height: '100%', objectFit: 'contain' };

    const VerificaImagens = () => {
        const temImagens = product.images && product.images.length > 0;

        if (!temImagens) {
            if (product.base64) {
                return <img src={`data:image/jpeg;base64,${product.base64}`} alt={product.use_descricao} style={imgStyle} />;
            }
            return <img src={SEM_IMAGEM} alt="Sem imagem" style={imgStyle} />;
        }

        const thumbUrl = (pos) => `${Config.base_fotos}/fotos/${product.produto}_${product.cor_produto}_${pos}.jpg`;
        const posicaoInicial = product.images.length > 1 ? '02' : '01';

        const handleError = ({ currentTarget }) => {
            if (posicaoInicial === '02' && currentTarget.dataset.fallback !== '01') {
                currentTarget.dataset.fallback = '01';
                currentTarget.src = thumbUrl('01');
                return;
            }
            currentTarget.onerror = null;
            currentTarget.src = FOTO_TRATAMENTO;
        };

        return (
            <img
                className="card-img-top"
                style={imgStyle}
                src={thumbUrl(posicaoInicial)}
                alt={product.use_descricao}
                onError={handleError}
            />
        );
    }

    return (
        <Card elevation={1} style={{ padding: 10, minHeight: 400 }} onClick={verProdutoProps}>
            <Stack direction={"column"} spacing={2}>
                <Box style={{ height: 220, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                    <VerificaImagens />
                </Box>
                <Stack direction={"column"} spacing={1}>
                    <Typography sx={{fontSize:12}}>{product.use_descricao}</Typography>
                    <Stack direction={"row"} spacing={1}>
                    <RowSimple
                            label={"REF"}
                            value={product.use_referencia}
                        />
                        <RowSimple
                            label={"Cod cor"}
                            value={product.use_cod_cor_produto}
                        />
                    </Stack>
                    <Stack spacing={1} direction="column">
                
                        <RowSimple
                            label={"Cor"}
                            value={product.use_cor_produto}
                        />
                        {product.grades && product.grades.length > 0 ? (
                            <Box>
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                    {product.grades.map((grade, index) => (
                                        <Chip 
                                            key={index}
                                            label={grade}
                                            size="small"
                                            sx={{background: '#666', color: '#ffffff', border:'none'}}
                                            variant="outlined"
                                        />
                                    ))}
                                </Stack>
                            </Box>
                        ) : (
                            <Box>
                                <Alert severity="error">
                                   SEM ESTOQUE
                                </Alert>
                            </Box>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </Card>
    )
}

export default CardProduct
